import React, {useState, useEffect} from 'react';
import NameFormatter from '../NameFormatter';
import QuantityFormatter from '../QuantityFormatter';
import './HeaderStats.css';
import {format} from 'date-fns';

function HeaderStats({url}) {
	const [headerData, setHeaderData] = useState({breakdown: {}, updated_at: '2020-03-25T20:00:14.566+00:00'});
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const getData = () => {
			setLoading(true);
			return fetch(url, {

			}).then(res => {
				if(!res.ok) {
					throw Error(res);
				}
				return res.json();
			}).then(response => {
				setLoading(false);
				setHeaderData(response);
			}).catch(e => {
				setLoading(false);
				console.log(e);
			})
		};

		getData();

		return () => {};
	}, [url]);

	const sortFunction = (a, b) => {
		const arrayOfMovements = ['doubleunders', 'squats', 'situps', 'lunges', 'pushups', 'kbswings', 'burpees', 'pullups', 'run', 'row']
		// const multiplierA = a[1].points / a[1].volume;
		// const multiplierB = b[1].points / b[1].volume;
		const indexA = arrayOfMovements.indexOf(a[0]);
		const indexB = arrayOfMovements.indexOf(b[0]);
		if(indexA < indexB) return -1;
		return 1;
	}

	function numberWithCommas(x) {
		x = Math.round(x);
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	if(loading) return null;
	return(<div className="">
		<div className="flex flex-wrap align-center justify-center ph3">
			<p className="mb2 mt0 tl pl3 w-100"><strong>World Stats</strong> <span className="f6">(updated at: { format(new Date(headerData.updated_at), 'h:mm aa') })</span></p>
			{(Object.entries(headerData.breakdown) || []).sort(sortFunction).map((value, idx) => 
				<div 
					key={idx}
					className={'header-stat pv3 w-20 tl' + (idx > 4 ? ' border-bottom' : '')}>
					<div className="header-stat__inner">
						<h4 className="mv0 fw6 number dib">{numberWithCommas(value[1].volume)}</h4><br/>
						<p className="mv0 ttc gray title dib">{NameFormatter(value[0])} ({QuantityFormatter(value[1].quantity)})</p>
					</div>
				</div>
			)}
		</div>
	</div>)
};

export default HeaderStats;